<template>
    <v-layout row justify-center>
      <v-dialog
        v-model="component.cancelBudgetDialog"
        :retain-focus="false"
        persistent
        max-width="500"
      >
        <v-card>
          <v-card-title class="headline"
            >Deseja cancelar este orçamento?</v-card-title
          >
          <v-card-text>Esta ação fará o cancelamento do orçamento</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="error"
              @click="
                () => {
                  component.setCancelDialog();
                }
              "
              >Não</v-btn
            >

            <v-btn
              color="success ml-4"
              @click="
                () => {
                  component.confirmCancelBudget();
                }
              "
              >Confirmar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </template>
    
    <script>
  export default {
    props: {
      component: Object,
    },
  };
  </script>
    
    <style>
  </style>